import { Component, OnInit, Output, EventEmitter, ViewChild, OnDestroy, Input, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DemoService } from '../../../shared/demo.service';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
import { RequestMetadata, PagedResult } from '../../../../../lib/ng-crud-table';
import { MatTableDataSource, MatSort } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator } from '@angular/material';
import { CommonFilter } from 'src/app/shared/models/Common/common-filter';
import { parse } from 'querystring';
import { NWSTAT_VQUAD } from 'src/app/shared/models/NWSTAT_VQUAD';
import { NWSTAT_VQUAD_CENTRALIPS } from 'src/app/shared/models/NWSTAT_VQUAD_CENTRALIPS';
import { environment } from 'src/environments/environment';
import { SelectionModel } from '@angular/cdk/collections';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { RemoteCommandType } from 'src/app/shared/models/Remote Operations/remote-operations';
import { DEVICE_CALL_STATUS } from 'src/app/shared/models/Remote Operations/network-status';
import { getDateValue, iterateAndWait } from 'lib/common/utils';
import { tap, delay } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { url } from 'inspector';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { VMobilescrparamsComponent } from '../v-mobilescrparams/v-mobilescrparams.component';
import { Subscription } from 'rxjs';
//import { MatRadioChange } from '@angular/material';

@Component({
  selector: 'app-v-mobile',
  templateUrl: './v-mobile.component.html',
  styleUrls: ['./v-mobile.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),

    trigger('fadeInOut', [
      state('in', style({ opacity: 100 })),
      transition('* => void', [
        animate(300, style({ opacity: 0 }))
      ])
    ]),


    //https://www.kdechant.com/blog/angular-animations-fade-in-and-fade-out
    // the fade-in/fade-out animation.
    trigger('simpleFadeAnimation', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(600)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(600, style({ opacity: 0 })))
    ]),

  ],
})
export class VMobileComponent implements OnInit, AfterViewInit, OnDestroy {//, OnDestroy {
  baseUrl: string;
  url: string;
  rsltType: string = "vMobile";
  title: string;
  staticScreen = true;
  isLoading = false;
  isSubLoading = {};
  data2: any;
  goToPage = null;
  centralIP1: string;
  centralIP2: string;
  centralIP3: string;
  centralIP4: string;
  centralIPsForm: FormGroup;
  centralIPsList = [];
  vquadID: number = 0;
  vquadScriptID: number = 0;
  isProfile: boolean = true;
  isProfileCheck: boolean = true;
  showConnectedNode: boolean = false;

  private commonFilter: CommonFilter;
  //private nwstatVQUAD: NWSTAT_VQUAD;

  //private generalFilterArray: Array<GeneralFilter>;
  @Output() childTitleEvent = new EventEmitter();

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  //dataSource = new MatTableDataSource();

  dataSource = new MatTableDataSource<any>([]);//any[]; //new MatTableDataSource(); //[];
  dataSource2 = [];

  //'select', 'RowExpand', 'Edit', 'Add', 'NodeIP_Abs'
  //'select', 
  columnsToDisplay = ['RowExpand', 'NodeIP_Abs', 'NodeVersion_Abs', 'GPS_Lat_Abs', 'GPS_Long_Abs', 'DeviceType_Abs'
    , 'ConsoleIP_Abs', 'ListenerIP_Abs',
    'DBTimestamp_Abs'];

  //https://www.dotnetcurry.com/angularjs/1424/angular-interpolation-property-data-binding
  //https://www.codementor.io/@adekunleoyaniyi/interpolation-vs-property-binding-in-angular2-eu1tzbyn4?utm_content=68092897&utm_medium=social&utm_source=twitter
  //https://stackoverflow.com/questions/47457134/angular-how-can-i-write-a-condition-in-interpolation
  //https://stackoverflow.com/questions/52749244/angular-6-function-call-within-html-interpolation-returns-undefined/52749481
  SetIPType(LocalIPType_Abs) {
    return LocalIPType_Abs == "0" ? "Auto Get Local IP" : (LocalIPType_Abs == "1" ? "Get Local IP from ..\\Profiles\\LocalIP.ini" : "Use this as Local IP");
  }
  isDisabled = {};
  onSelectionChanged(matSelected, index) {
    //console.log(matSelected.value)
    if (matSelected.value == "2")
      this.isDisabled[index] = false;
    else
      this.isDisabled[index] = true;
  }
  GetCentralIPLabel(CentralIPIndex_Abs) {

    return CentralIPIndex_Abs == "0" ? "Primary IP" : (CentralIPIndex_Abs == "1" ? "Secondary IPs" : "");
  }
  GetCentralIPInput(CentralIPIndex_Abs) {

    return CentralIPIndex_Abs == "0" ? "Primary IP" : "Secondary IP" + CentralIPIndex_Abs;
  }
  GetCentralIPLabelClass(CentralIPIndex_Abs) {

    return CentralIPIndex_Abs == "0" ? "PrimaryIPNew" : (CentralIPIndex_Abs == "1" ? "SecondaryIPNew" : "");
  }
  SetNodeStatus(NodeTimestamp_Abs, NodeStatus_Abs) {
    if (NodeStatus_Abs == '1') {
      return 2;
    }

    let timeDiffinSec = parseInt(NodeTimestamp_Abs);
    //console.log(timeDiffinSec)
    if (timeDiffinSec > 60 || timeDiffinSec < -60)
      return 1;
    else
      return 0;
  }
  SetLatestTSFormat(column) {
    return getDateValue(column, "DBTimestamp_Abs");
  }
  //https://medium.com/showpad-engineering/why-you-should-never-use-function-calls-in-angular-template-expressions-e1a50f9c0496
  SetNodeStatusClass(ID_Abs) {
    let className = "click";
    //https://stackoverflow.com/a/54805140 - Not used
    for (const key in this.scrpitStatuses) {
      if (this.scrpitStatuses[key]) {
        //debugger;
        if (this.scrpitStatuses[key].NodeID == ID_Abs) {
          className = this.scrpitStatuses[key].DevicesRunning > 0 ? "greenTick" : "blueTick";// "blink" "blink click" : "click";
          break;
        }
      }
    }
    return className;
  }
  //CheckMac(ChkMAC_Abs) {
  //  return ChkMAC_Abs == "GrabMAC" ? "ON" : "OFF";
  //}
  //CheckBTName(ChkBTName_Abs) {
  //  return ChkBTName_Abs == "UseBTName" ? "ON" : "OFF";
  //}
  //BackCheckMac(ChkMAC_Abs) {
  //  return ChkMAC_Abs == "ON" ? "GrabMAC" : "";
  //}
  //BackCheckBTName(ChkBTName_Abs) {
  //  return ChkBTName_Abs == "ON" ? "UseBTName" : "";
  //}

  SetScriptStatus(ScriptStatus_Abs) {
    if (ScriptStatus_Abs == '2')
      return 1;
    else
      return 0;
  }


  vquadScriptColumns = ['DeviceName_Abs', 'ScriptName_Abs', 'Call_Status_Abs', 'GlobalDevice', 'StartStop', 'ScriptStatus_Abs'];//, 'Edit'

  expandedElement: PeriodicElement | null;


  tableDef: Array<any> = [
    {
      key: 'ID_Abs',
      header: 'ID'
    },
    {
      key: 'NodeIP_Abs',
      header: 'Computer Name'
    }, {
      key: 'NodeVersion_Abs',
      header: 'Version'
    }, {
      key: 'NodeTimestamp_Abs',
      header: 'NodeTimestamp'
    },
    {
      key: 'NodeTimezone_Abs',
      header: 'NodeTimezone'
    }, {
      key: 'NodeAlias_Abs',
      header: 'vMobile Name'
    }, {
      key: 'GPS_Lat_Abs',
      header: 'Latitude'
    }, {
      key: 'GPS_Long_Abs',
      header: 'Longitutde'
    },
    {
      key: 'DeviceType_Abs',
      header: 'Device Type'
    }, {
      key: 'NodeIPAddr_Abs',
      header: 'IP Address'
    }, {
      key: 'NodeLocation_Abs',
      header: 'Location'
    }, {
      key: 'DualUTAInfo_Abs',
      header: 'Dual UTA'
    }, {
      key: 'DBTimestamp_Abs',
      header: 'Latest Timestamp'
    }, {
      key: 'NodeStatus_Abs',
      header: 'vMobile Status'
    },
    {
      key: 'ChkBTName_Abs',
      header: 'Use BT Name'
    },
    {
      key: 'ChkMAC_Abs',
      header: 'Grab Mac'
    },
    {
      key: 'CentralIP_Abs',
      header: 'CentralDB IP Addresses'
    },

  ]

  // MatPaginator Inputs
  length = 100;
  pageSize = 20;
  pageSizeOptions: number[] = [1, 10, 25, 100];
  pageIndex = 0;

  // MatPaginator Output
  pageEvent: PageEvent;
  //mySubscription: any;

  AutoRefreshInfo: any;
  interval;
  private subscriptions: Subscription[] = [];

  constructor(private commonFilterService: CommonFilterService, private http: HttpClient, private demoService: DemoService, private dialog: MatDialog, private _formBuilder: FormBuilder, private router: Router) {

    this.baseUrl = environment.urlAddress + '/api/';
    this.commonFilterService.setNonFiltersScreen(true);

    this.centralIPsForm = this._formBuilder.group({
      dummyCentralIPsArray: this._formBuilder.array(this.centralIPsList)
    });

    //Do Refresh
    const _broadSubRefresh =  this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        this.LoadNSvMobileData();
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(res)
        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);

            this.LoadNSvMobileData();
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  //ngOnDestroy() {
  //  if (this.mySubscription) {
  //    this.mySubscription.unsubscribe();
  //  }
  //}
  ngAfterViewInit() {
    //setTimeout(() => this.dataSource.paginator = this.paginator);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  get dummyCentralIPsArray(): FormArray {
    return this.centralIPsForm.get('dummyCentralIPsArray') as FormArray;
  }

  //https://javascript.developreference.com/article/11284307/Angular+6+-+How+to+reload+current+page%3F
  //https://stackoverflow.com/questions/57325155/how-to-reload-whole-page-without-refresh-in-angular-7-8
  //https://blogs.ibs.com/2018/07/10/angular-refreshing-a-route-with-parameters/
  //https://www.youtube.com/watch?v=LEI9yrTIrCM
  //https://dzone.com/articles/refresh-angular-component-without-reload-or-naviga
  //https://medium.com/engineering-on-the-incline/reloading-current-route-on-click-angular-5-1a1bfc740ab2
  //https://www.quora.com/How-do-I-auto-reload-my-Angular-2-4-app-after-clicking-a-certain-button
  OnReloadRoute() {
    //this.router.navigateByUrl('statistics/nsvquad');
    this.commonFilterService.basicRefresh();
  }
  ngOnInit() {
    //this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //  return false;
    //};
    //this.mySubscription = this.router.events.subscribe((event) => {
    //  if (event instanceof NavigationEnd) {
    //    // Trick the Router into believing it's last link wasn't previously loaded
    //    this.router.navigated = false;

    //    // if you need to scroll back to top, here is the right place
    //    window.scrollTo(0, 0);
    //  }
    //});


    //debugger;

    /////////////////// Call function

    //let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //let options = {
    //  headers: headers
    //};

    //this.url = environment.urlAddress + '/api/' + requestMeta.rsltType + '/Post' + requestMeta.rsltType;
    //this.url = this.url + 'vMobileData' + '/Post' + 'vMobileNS';

    //return this.http.get<PagedResult>(this.url, { params })
    //https://www.techiediaries.com/angular-http-client/
    //https://stackoverflow.com/questions/50330342/how-to-send-post-in-angular5-with-multiple-params
    //https://weblog.west-wind.com/posts/2012/May/08/Passing-multiple-POST-parameters-to-Web-API-Controller-Methods
    //https://www.dotnetcurry.com/aspnet/1278/aspnet-webapi-pass-multiple-parameters-action-method

    this.LoadNSvMobileData();
    //this.GetData().subscribe((res: any) => {
    //  //console.log(res);
    //  let rows: any[] = JSON.parse(res) as any[];
    //  //console.log(rows);
    //  this.dataSource = rows;

    //});

  }


  updateManualPage() {
    //debugger;
    // this.manualPage = index;
    this.paginator.pageIndex = this.goToPage - 1;
    this.LoadNSvMobileData(this.paginator);
  }


  //load default data
  currentPage: number;
  scrpitStatuses: Array<any> = [];

  radioChange($event) {//: MatRadioChange) {
    //console.log($event.source.name, $event.value);

    //if ($event.source.name === 'radioOpt1') {
    //  // Do whatever you want here
    //}

    this.LoadNSvMobileData();
  }

  @Input() StatusvMobileID: number = 0;
  vMobileOrvMobileOption: string = "1";
  showNodeStatus = false;
  LoadNSvMobileData(event?: PageEvent) {
    if (this.prevRowIndex !== -1)
      this.UndoRow(this.prevRowData, this.prevRowIndex);
    //debugger;
    this.isLoading = true;
    this.commonFilter = new CommonFilter();
    this.commonFilter.ShowNodeConnected = this.showConnectedNode;
    this.commonFilter.TimestampType = parseInt(this.vMobileOrvMobileOption);
    if (event != undefined) {

      this.currentPage = +event.pageIndex + +1;
      //this.url = this.baseUrl + 'NwStat_vMobile/GetvMobiles_New?perPage=' + event.pageSize + '&pageNumber=' + this.currentPage;
      this.url = this.baseUrl + 'NwStat_vMobile/GetvMobiles_New';
      this.commonFilter.PerPage = event.pageSize.toString();
      this.commonFilter.PageNumber = this.currentPage.toString();

    } else {
      this.url = this.baseUrl + 'NwStat_vMobile/GetvMobiles_New';
      this.commonFilter.PerPage = this.pageSize.toString();
      this.commonFilter.PageNumber = "1";
    }
    //console.log(this.StatusvMobileID)
    if (this.StatusvMobileID != 0) {
      this.url = this.baseUrl + 'NwStat_vMobile/GetvMobileByID_New';
      this.commonFilter.ResultOrFileType = this.StatusvMobileID;
    }

    this.GetData(this.commonFilter).subscribe((res: any) => {
      if (res !== 'null') {
        let rows: any[] = JSON.parse(res) as any[];
        //debugger
        this.length = rows.length;
        this.scrpitStatuses = [];
        for (const index in rows) {
          //rows[index].ChkBTName_Abs = this.CheckBTName(rows[index].ChkBTName_Abs);
          //rows[index].ChkMAC_Abs = this.CheckMac(rows[index].ChkMAC_Abs);
          this.GetvMobileScriptsRunningCntData(rows[index].ID_Abs).subscribe((cnt: number) => {
            let scriptStatInfo = { NodeID: rows[index].ID_Abs, DevicesRunning: cnt }
            this.scrpitStatuses.push(scriptStatInfo)
          });
        }

        this.dataSource.data = rows;
      }
      this.isLoading = false;
      //this.length = rows.length;
    });

    //https://stackoverflow.com/questions/45318164/how-to-use-paginator-from-material-angular
    return event;
  }

  /// expanded bind
  isStartStop = {};
  currNodeID = -1;
  currElemRowIndex = -1;
  CallFunc(nodeID: number, elemRowIndex, column) {
    if (this.expandedElement === column) {
      if (this.prevSubRowIndex !== -1)
        this.UndoScriptRow(this.prevSubRowData, this.prevSubRowIndex);

      this.isSubLoading[elemRowIndex] = true;
      //console.log(nodeID);
      this.currNodeID = nodeID;
      this.currElemRowIndex = elemRowIndex;

      this.GetvMobileScriptNamesList(nodeID).subscribe((res: any) => {
        //console.log("Next")
        let rows: any[] = JSON.parse(res) as any[];
        if (rows.length == 0)//fresh node to be asked to send scripts info for the first time
          this.GetLatestScriptsListOnExpand(nodeID);
        //console.log(rows)
        this.selectProfilesScriptsList = rows;
      });

      this.GetvMobileScriptData(nodeID).subscribe((res: any) => {
        //console.log(res);
        let rows: any[] = JSON.parse(res) as any[];
        //console.log(rows);
        for (const key in rows) {
          if (rows[key]) {
            if (rows[key].ScriptStatus_Abs == 2)
              this.isStartStop[rows[key].DeviceIndex_Abs - 1] = true;
            else
              this.isStartStop[rows[key].DeviceIndex_Abs - 1] = false;
          }
        }
        this.dataSource2 = rows;
        this.isSubLoading[elemRowIndex] = false;
        //this.dataSource2 = ELEMENT_DATA;
        //console.log(element);
      });
    }
  }

  //// open dilaog box
  //https://blog.angular-university.io/angular-material-dialog/
  //https://iknowthatnow.com/2018/05/11/angular-material-dialog/
  //https://stackoverflow.com/questions/51815455/how-to-pass-data-from-angular-material-dialog-to-parent-component
  scrparams: string[];
  successMsgGlobalStartVar: boolean = false;
  OpenGlobalStartVarDialog(devID: number, devIndex, NodeTimestamp_Abs, NodeStatus_Abs) {

    //console.log('test');
    //console.log(nodeID);
    //this.GetBTFXO(nodeID).subscribe((res: any) => {
    //console.log(res);
    //  let rows: any[] = JSON.parse(res) as any[];
    // //console.log(rows[0]);
    //  this.btfxo = rows[0].BTName_Abs;

    //});

    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "55%";
    let nodeStatus = this.SetNodeStatus(NodeTimestamp_Abs, NodeStatus_Abs) === 0;
    let finalEditStatus = false;
    if (nodeStatus)
      finalEditStatus = this.isStartStop[devIndex - 1];
    //console.log(devIndex)
    dailogConfig.data = { pageValue: devID, devRowEditable: finalEditStatus };

    const dialogRef = this.dialog.open(VMobilescrparamsComponent, dailogConfig);

    dialogRef.afterClosed().subscribe(
      data => { this.successMsgGlobalStartVar = data; }
    );
  }


  GetDataBCK() {

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers
    };

    return this.http.post<any>(this.url, options)
      .toPromise()
      .then(function (res) {
        //.subscribe(function (res) {
        //debugger;

        let rows: any[] = JSON.parse(res) as VQUADDATA[];
        let filteredData = res;//rows;
        //console.log(filteredData);
        //console.log(rows);

        return rows;
      });
    //.bind(this))
    //.catch(this.handleError.bind(this));
  }

  GetData(commFilter: CommonFilter) {

    //debugger;

    //  this.url = this.baseUrl + 'NwStat_vMobile/GetvMobiles_New';
    //JSON.stringify({ commonFilter: commFilter, generalFilterArray: generalFilterArr })

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    //var body = {
    //  PageNumber: this.commonFilter.PageNumber, PerPage: this.commonFilter.PerPage
    //}
    //return this.http.post<any>(this.url, "", { headers: headerOptions }); for post 3 agrument and for get 2 arguments // JSON.stringify({ commonFilter: this.commonFilter })
    return this.http.post<any>(this.url, commFilter, options);
    // return this.http.get<any>(this.url,  options);

  }

  GetvMobileScriptData(nodeID: number) {
    //let params = new HttpParams()
    //  .set('TSType', TSType)
    //  .set('PageNumber', '1')
    //  .set('TSBetween', TSBetween)
    //  .set('Sort', 'descending');

    this.url = this.baseUrl + 'NwStat_vMobile/GetScriptsByNodeID_New?nodeID=' + nodeID;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(this.url, { headers: headerOptions });
    //.map((data: Response) => {
    //  return data.json() as EachVqtPolqa[];
    //}).toPromise().then(x => {
    //  this.eachVqtPolqaList = x;
    //})
  }
  GetvMobileScriptsRunningCntData(nodeID: number) {
    //let params = new HttpParams()
    //  .set('TSType', TSType)
    //  .set('PageNumber', '1')
    //  .set('TSBetween', TSBetween)
    //  .set('Sort', 'descending');

    this.url = this.baseUrl + 'NwStat_vMobile/GetScriptsRunningCntByNodeID?nodeID=' + nodeID;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<number>(this.url, { headers: headerOptions });
    //.map((data: Response) => {
    //  return data.json() as EachVqtPolqa[];
    //}).toPromise().then(x => {
    //  this.eachVqtPolqaList = x;
    //})
  }

  GetBTFXO(nodeID: number) {

    this.url = this.baseUrl + 'NwStat_vMobile/GetBtFxosByNodeID_New?nodeID=' + nodeID;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(this.url, { headers: headerOptions });

  }

  parentEvent(title) {
    //debugger;

    this.title = title;
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  //Edit Node network info
  isEditable = {};
  EditRow(rowData: any, rowIndex) {
    if (this.prevRowIndex !== -1)
      this.UndoRow(this.prevRowData, this.prevRowIndex);
    this.prevRowData = rowData;
    this.prevRowIndex = rowIndex;

    this.isEditable[rowIndex] = true;
    this.vquadID = rowData.ID_Abs;

    //this.centralIPsList = [];
    //let cntIPs = 0;
    //for (const key in rowData.CentralIP_Abs) {
    //  if (rowData.CentralIP_Abs[key] !== 'null')
    //    this.centralIPsList.push(rowData.CentralIP_Abs[key]);
    //  else
    //    this.centralIPsList.push("");
    //  cntIPs++;
    //}
    //for (var i = cntIPs; i < 4; i++)
    //  this.centralIPsList.push("");

    //// if receiving data at a later point, use below instead - IMP
    //this.centralIPsForm.setControl('dummyCentralIPsArray', this._formBuilder.array(this.centralIPsList));

    //this.dataSource = this.dataSource.filter((value, key) => {
    //  if (value.ID_Abs == rowData) {
    //    this.editRow = true;
    //  }
    //  else
    //    this.editRow = false;
    //  return true;
    //});
  }

  //Update node info in DB for DataImport to send 
  UpdateRow(rowData: any, rowIndex) {
    this.isEditable[rowIndex] = false;
    //console.log(rowData);
    this.vquadID = 0;

    //let newCentralIPList: { [id: number]: string; } = {};//[];
    //for (var i = 0; i < 4; i++)
    //  newCentralIPList[i] = this.dummyCentralIPsArray.value[i];//this.centralIPsList[i];

    //rowData.CentralIP_Abs = newCentralIPList;
    ////console.log(rowData.CentralIP_Abs)
    this.UpdatevMobileData(rowData).subscribe((res: any) => {

      //rowData.ChkBTName_Abs = this.CheckBTName(rowData.ChkBTName_Abs);
      //rowData.ChkMAC_Abs = this.CheckMac(rowData.ChkMAC_Abs);
    });

    //this.dataSource = this.dataSource.filter((value, key) => {
    //  if (value.ID_Abs == rowData.ID_Abs) {
    //    value.ID_Abs = rowData.ID_Abs;
    //    value.NodeAlias_Abs = rowData.NodeAlias_Abs;
    //    value.GPS_Lat_Abs = rowData.GPS_Lat_Abs;
    //    value.GPS_Long_Abs = rowData.GPS_Long_Abs;
    //    value.NodeLocation_Abs = rowData.NodeLocation_Abs;
    //    value.NodeIPAddr_Abs = rowData.NodeIPAddr_Abs;
    //    value.CentralIP_Abs = rowData.CentralIP_Abs;
    //    value.ChkBTName_Abs = rowData.ChkBTName_Abs;
    //    value.ChkMAC_Abs = rowData.ChkMAC_Abs;
    //  }
    //  return true;
    //});
    this.isLoading = true;
    setTimeout(() => { this.isLoading = false; this.OnReloadRoute(); }, 8000);
  }
  //change disconnected node to OOS
  changeToOOSRow(rowData: any) {//, rowIndex) {

    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "40%";
    dailogConfig.data = { title: "Confirm Action", message: "Are you sure you want to change status to Out of Service?" };

    this.dialog.open(ConfirmDialogComponent, dailogConfig).afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        //this.isEditable[rowIndex] = !this.isEditable[rowIndex];
        // console.log(rowData);
        this.vquadID = 0;

        rowData.NodeStatus_Abs = 1;

        this.UpdateOOSvMobileData(rowData).subscribe((res: any) => {
        });

        //this.dataSource = this.dataSource.filter((value, key) => {
        //  if (value.ID_Abs == rowData.ID_Abs) {
        //    value.ID_Abs = rowData.ID_Abs;
        //    value.NodeAlias_Abs = rowData.NodeAlias_Abs;
        //    value.GPS_Lat_Abs = rowData.GPS_Lat_Abs;
        //    value.GPS_Long_Abs = rowData.GPS_Long_Abs;
        //    value.NodeLocation_Abs = rowData.NodeLocation_Abs;
        //    value.NodeIPAddr_Abs = rowData.NodeIPAddr_Abs;
        //    value.CentralIP_Abs = rowData.CentralIP_Abs;
        //    value.ChkBTName_Abs = rowData.ChkBTName_Abs;
        //    value.ChkMAC_Abs = rowData.ChkMAC_Abs;
        //  }
        //  return true;
        //});
        this.isLoading = true;
        setTimeout(() => { this.isLoading = false; this.OnReloadRoute(); }, 3000);
      }
    });

  }

  //Cancel editing node
  prevRowData: any;
  prevRowIndex = -1;
  UndoRow(rowData: any, rowIndex) {
    this.isEditable[rowIndex] = false;

    this.vquadID = 0;

    this.dataSource.data = this.dataSource.data.filter((value, key) => {
      if (value.ID_Abs == rowData.ID_Abs) {
        value.ID_Abs = rowData.ID_Abs;
        //value.NodeAlias_Abs = rowData.NodeAlias_Abs;
        value.GPS_Lat_Abs = rowData.GPS_Lat_Abs;
        value.GPS_Long_Abs = rowData.GPS_Long_Abs;
        value.NodeLocation_Abs = rowData.NodeLocation_Abs;
        //value.NodeIPAddr_Abs = rowData.NodeIPAddr_Abs;
        //value.CentralIP_Abs = rowData.CentralIP_Abs;
        //value.ChkBTName_Abs = rowData.ChkBTName_Abs;
        //value.ChkMAC_Abs = rowData.ChkMAC_Abs;
      }
      return true;
    });

  }

  UpdatevMobileData(rowData: any) {
    //debugger;
    //console.log(rowData)
    this.url = this.baseUrl + 'NwStat_vMobile/UpdateNwStat_vMobile';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    //var body = {
    //  PageNumber: this.commonFilter.PageNumber, PerPage: this.commonFilter.PerPage
    //}
    //return this.http.post<any>(this.url, "", { headers: headerOptions }); for post 3 agrument and for get 2 arguments // JSON.stringify({ commonFilter: this.commonFilter })
    return this.http.post<any>(this.url, rowData, options);

  }
  UpdateOOSvMobileData(rowData: any) {
    //debugger;

    this.url = this.baseUrl + 'NwStat_vMobile/UpdateNwStatOOS_vMobile';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    //var body = {
    //  PageNumber: this.commonFilter.PageNumber, PerPage: this.commonFilter.PerPage
    //}
    //return this.http.post<any>(this.url, "", { headers: headerOptions }); for post 3 agrument and for get 2 arguments // JSON.stringify({ commonFilter: this.commonFilter })
    return this.http.post<any>(this.url, rowData, options);

  }

  ///  ////////////// vMobile Script
  //Edit script row
  isSubEditable = {};
  selectProfilesScriptsList = [];
  currScriptName = "";
  //currScriptWebviewerName = "";
  //prevScriptName = "";
  //prevScriptWebviewerName = "";
  scriptOption: string = "1";
  selectedNodeIDScriptRef = -1;
  ScriptEditRow(rowData: any, rowIndex, elemRowIndex) {
    this.isSubLoading[elemRowIndex] = true;
    if (this.prevSubRowIndex !== -1)
      this.UndoScriptRow(this.prevSubRowData, this.prevSubRowIndex);
    this.prevSubRowData = rowData;
    this.prevSubRowIndex = rowIndex;

    this.isSubEditable[rowIndex] = true;
    this.vquadScriptID = rowData.ID_Abs;

    //this.currScriptWebviewerName = rowData.Script_Webviewer_Abs;
    this.currScriptName = "";
    this.scriptOption = "2";//User defined
    if (rowData.ScriptName_Abs !== null) {// && rowData.Script_Webviewer_Abs === null) {
      this.currScriptName = rowData.ScriptName_Abs;
      //this.currScriptWebviewerName = "";
      this.scriptOption = "1";//Profiles
    }
    //this.prevScriptWebviewerName = this.currScriptWebviewerName;
    //this.prevScriptName = this.currScriptName;

    //https://stackoverflow.com/questions/58220642/delay-inside-after-subscribe-in-angular
    //https://www.learnrxjs.io/learn-rxjs/operators/utility/delay
    //this.UpdateScriptInfoCmd(rowData.NodeID_Abs).pipe(delay(3000)).subscribe((res: any) => {
    //this.iterateAndWait();
    //});
    if (this.selectedNodeIDScriptRef != rowData.NodeID_Abs) {
      this.selectedNodeIDScriptRef = rowData.NodeID_Abs;//when a new node's script info request needed

      //this.UpdateScriptInfoCmd(rowData.NodeID_Abs).pipe(
      //  tap(() => { }),
      //  delay(5000),
      //).subscribe(() => {
      //console.log("Started")
      //this.UpdateScriptInfoCmd(rowData.NodeID_Abs).subscribe(() => {
      //console.log("Done")
      this.GetvMobileScriptNamesList(rowData.NodeID_Abs).subscribe((res: any) => {
        //console.log("Next")
        let rows: any[] = JSON.parse(res) as any[];
        if (rows.length == 0)//fresh node to be asked to send scripts info for the first time
          this.GetLatestScriptsList(rowData, elemRowIndex);
        //console.log(rows)
        this.selectProfilesScriptsList = rows;
        this.isSubLoading[elemRowIndex] = false;
      });
      //});
    }
    else {//get script list from db without requested node for latest script info again
      this.GetvMobileScriptNamesList(rowData.NodeID_Abs).subscribe((res: any) => {
        //console.log("Next")
        let rows: any[] = JSON.parse(res) as any[];
        if (rows.length == 0)//fresh node to be asked to send scripts info for the first time
          this.GetLatestScriptsList(rowData, elemRowIndex);
        //console.log(rows)
        this.selectProfilesScriptsList = rows;
        this.isSubLoading[elemRowIndex] = false;
      });
    }

    //this.dataSource2 = this.dataSource.filter((value, key) => {
    //  if (value.ID_Abs == rowData.ID_Abs) {
    //    this.scriptEditRow = true;        
    //  }
    //  else {
    //    this.scriptEditRow = false;
    //  }
    //  return true;
    //});
  }
  GetLatestScriptsList(rowData, elemRowIndex, refreshClicked?) {
    this.isSubLoading[elemRowIndex] = true;
    this.UpdateScriptInfoCmd(rowData.NodeID_Abs).subscribe(() => {
      this.GetvMobileScriptNamesList(rowData.NodeID_Abs, refreshClicked).subscribe((res: any) => {
        let rows: any[] = JSON.parse(res) as any[];
        //console.log(rows)
        this.selectProfilesScriptsList = rows;
        this.isSubLoading[elemRowIndex] = false;
      });
    });
  }
  GetLatestScriptsListOnExpand(nodeID) {
    this.UpdateScriptInfoCmd(nodeID).subscribe(() => {
      this.GetvMobileScriptNamesList(nodeID).subscribe((res: any) => {
        let rows: any[] = JSON.parse(res) as any[];
        //console.log(rows)
        this.selectProfilesScriptsList = rows;
      });
    });
  }

  //changeControl(control: string) {
  //  if (control == "profile") 
  //    this.isProfile = true;
  //  else
  //    this.isProfile = false;
  //}

  //Set flag to get script file names list saved under AppInfo table under respective node ID\
  UpdateScriptInfoCmd(nodeID: number) {

    this.url = this.baseUrl + 'NwStat_vMobile/UpdateNwStat_vMobileScriptInfoCmd?nodeID=' + nodeID;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    //return this.http.post<any>(this.url, "", { headers: headerOptions }); for post 3 agrument and for get 2 arguments // JSON.stringify({ commonFilter: this.commonFilter })
    return this.http.get<any>(this.url, options);
  }

  GetvMobileScriptNamesList(nodeID: number, refreshClicked?) {
    //let params = new HttpParams()
    //  .set('TSType', TSType)
    //  .set('PageNumber', '1')
    //  .set('TSBetween', TSBetween)
    //  .set('Sort', 'descending');

    if (refreshClicked) { }
    else
      refreshClicked = false;
    this.url = this.baseUrl + 'NwStat_vMobile/GetScriptsNamesByNodeID_New?nodeID=' + nodeID + '&refreshClicked=' + refreshClicked;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any>(this.url, { headers: headerOptions });
    //.map((data: Response) => {
    //  return data.json() as EachVqtPolqa[];
    //}).toPromise().then(x => {
    //  this.eachVqtPolqaList = x;
    //})
  }


  //Update script info in DB for remote control
  UpdateScriptRow(rowData: any, rowIndex, elemRowIndex) {
    this.isSubEditable[rowIndex] = false;
    this.vquadScriptID = 0;
    //console.log(rowData);

    //Load Script operation
    //vMobileTestScripts\Bluetooth\Bluetooth_Bidirectional_RTD^Stopped;^;^;^;^;^;^;^;^;^;^;^
    let loadScript = false;
    if (this.currScriptName != rowData.ScriptName_Abs) {// && this.scriptOption === "1") {
      loadScript = true;
      //rowData.Script_Webviewer_Abs = "";
      rowData.ScriptName_Abs = this.currScriptName;//"C:\\\\Program Files (x86)\\\\GL Communications Inc\\\\vMobile\\\\Profiles\\\\" + this.currScriptName;
    }
    //else if (this.currScriptWebviewerName != rowData.Script_Webviewer_Abs && this.scriptOption === "2") {
    //  loadScript = true;
    //  rowData.ScriptName_Abs = "";
    //  //https://stackoverflow.com/a/38129176
    //  rowData.Script_Webviewer_Abs = this.currScriptWebviewerName.replace(/\\/g, "\\\\");
    //}
    //console.log(rowData)
    if ((loadScript == true && (this.currScriptName.length !== 0 && this.scriptOption === "1")) || this.successMsgGlobalStartVar === true) {// || (this.currScriptWebviewerName.length !== 0 && this.scriptOption === "2")
      //this.isSubLoading[elemRowIndex] = true;
     this.InsertRemoteOperation(rowData, RemoteCommandType.START_SCRIPT).subscribe((res: any) => {
       //this.isSubLoading[elemRowIndex] = false;
      });
    }

    this.UpdatevMobileScriptData(rowData).subscribe((res: any) => {
    });

    this.dataSource2 = this.dataSource2.filter((value, key) => {
      if (value.ID_Abs == rowData.ID_Abs) {
        value.ID_Abs = rowData.ID_Abs;
        value.ScriptName_Abs = this.currScriptName;
        //value.Script_Webviewer_Abs = this.currScriptWebviewerName != null ? (this.currScriptWebviewerName.length > 0 ? this.currScriptWebviewerName : null) : null;
        value.GlobalDevice = rowData.GlobalDevice;
      }
      return true;
    });
    //this.isSubLoading = true;
    //setTimeout(() => { this.isSubLoading = false; this.CallFunc(this.currNodeID, this.currElemRowIndex); }, 6000); 

  }
  //Cancel back to script original row
  prevSubRowData: any;
  prevSubRowIndex = -1;
  UndoScriptRow(rowData: any, rowIndex) {
    this.isSubEditable[rowIndex] = false;
    this.vquadScriptID = 0;
    this.dataSource2 = this.dataSource2.filter((value, key) => {
      if (value.ID_Abs == rowData.ID_Abs) {
        value.ID_Abs = rowData.ID_Abs;
        value.ScriptName_Abs = rowData.ScriptName_Abs;//this.currScriptName;
        //value.Script_Webviewer_Abs = rowData.Script_Webviewer_Abs;//this.currScriptWebviewerName != null ? (this.currScriptWebviewerName.length > 0 ? this.currScriptWebviewerName : null) : null; 
        value.GlobalDevice = rowData.GlobalDevice;
      }
      return true;
    });
  }

  UpdatevMobileScriptData(rowData: any) {
    this.url = this.baseUrl + 'NwStat_vMobile/UpdateNwStat_vMobileScripts';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, rowData, options);
  }

  callStatusClass(Call_Status_Abs: string) {
    if (Call_Status_Abs == null)
      return 'td_expanded IdleOrDisconn';

    let callStatus: string = Call_Status_Abs;
    if (callStatus.indexOf('Idle') != -1 || callStatus.indexOf('Disconn') != -1)
      return 'td_expanded IdleOrDisconn';
    else
      return 'td_expanded Connected';
  }

  ////https://stackoverflow.com/questions/36006894/angular2-get-clicked-element-id
  //StartStop(event, elem) {
  //  var target = event.target || event.srcElement || event.currentTarget;
  //  var idAttr = target.attributes.id;
  //  var value = idAttr.nodeValue;
  //}
  StartStop(elem, elemRowIndex) {
    this.isStartStop[elem.DeviceIndex_Abs - 1] = !this.isStartStop[elem.DeviceIndex_Abs - 1];
    //console.log(this.isStartStop[elem.DeviceIndex_Abs - 1])
    let remoteCmd = RemoteCommandType.STOP_SCRIPT;
    elem.ScriptStatus_Abs = '2';//IMP for script stat icon chnage
    if (!this.isStartStop[elem.DeviceIndex_Abs - 1]) {
      remoteCmd = RemoteCommandType.START_SCRIPT;
      elem.ScriptStatus_Abs = '1';
    }
    this.isSubLoading[elemRowIndex] = true;
    this.InsertRemoteOperation(elem, remoteCmd).subscribe((res: any) => {
      this.isSubLoading[elemRowIndex] = false;
    });
  }
  InsertRemoteOperation(rowData: any, remoteCmd: RemoteCommandType) {
    this.url = this.baseUrl + 'NwStat_vMobile/InsertNwStat_vMobileScriptsRemoteOperation';
    let body = JSON.stringify({ nwstat_vMobileScripts_Abs: rowData, remoteCmd: remoteCmd });
    //console.log(body);
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, body, options);
  }

  ///////////////////// checkbox selection
  selection = new SelectionModel<any>(true, []);

  //** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {

    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data != null ? this.dataSource.data.length : 0;
    return numSelected === numRows;
  }

  //** Selects all rows if they are not all selected; otherwise clear selection. */
  delButton: boolean;
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));

    this.delbuttonSet(1);
  }
  delbuttonSet(type, row?) {
    if (type == 2)
      this.selection.toggle(row);

    if (this.selection.selected.length > 0)
      this.delButton = true;
    else
      this.delButton = false;
  }

  //** The label for the checkbox on the passed row */
  //checkboxLabel(id: number, row?: any): string {

  //  if (id == 1) {
  //    if (!row) {
  //      id = 0;
  //      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;

  //    }
  //    id = 0;
  //    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  //  }
  //  else {
  //    this.selection.deselect();
  //    this.selection.clear();
  //  }
  //}
  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }
  selectedRow: string;
  DeleteNSvMobile(rowData?: any) {
    //DeleteNSvMobile(ID_Abs) {
    this.selectedRow = '';
    if (rowData)
      this.selectedRow += rowData.ID_Abs + ',';
    else {
      this.dataSource.data.filter((value, key) => {
        if (this.selection.isSelected(value)) {
          this.selectedRow += value.ID_Abs + ',';
        }
      });
    }
    //this.selectedRow = ID_Abs + ',';

    if (this.selectedRow != '') {
      const dailogConfig = new MatDialogConfig();
      dailogConfig.disableClose = true;
      dailogConfig.autoFocus = true;
      // dailogConfig.restoreFocus = true;
      dailogConfig.width = "40%";
      dailogConfig.data = { title: "Confirm Action", message: "Are you sure, you want to delete selected records?" };

      this.dialog.open(ConfirmDialogComponent, dailogConfig).afterClosed().subscribe(dialogResult => {
        if (dialogResult) {
          this.DeletevMobileData(this.selectedRow).subscribe((res: any) => {
            //this.LoadNSvMobileData();
            this.isLoading = true;
            setTimeout(() => { this.isLoading = false; this.OnReloadRoute(); }, 8000);
          });
        }
      });

      //if (confirm("Are you sure, you want to delete selected records?")) {
      //  this.DeletevMobileData(this.selectedRow).subscribe((res: any) => {
      //    this.LoadNSvMobileData();
      //  });
      //}
    }

  }

  DeletevMobileData(nsvMobileID: string) {
    this.url = this.baseUrl + 'NwStat_vMobile/DeleteNwStat_vMobile?nsVquaIDs=' + nsvMobileID;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);
  }
  ///////////////////////////////////// end checkbox

  ShowNodeConnected() {
    this.showConnectedNode = !this.showConnectedNode;
    this.LoadNSvMobileData();
  }

}

export interface VQUADDATA {
  ID: string;
  vMobile_Timestamp: string;
  GPS_Position: string;
  Call_Control_Event: string;
  description: string;
}
const Dummy_Data: VQUADDATA[] =
  [
    {
      "ID": "101",
      "vMobile_Timestamp": "2fdsfdsf",
      "GPS_Position": "gfd",
      "Call_Control_Event": "inner1",
      "description": "a"
    },
    {
      "ID": "201",
      "vMobile_Timestamp": "453gf7",
      "GPS_Position": "fgdf",
      "Call_Control_Event": "inner1",
      "description": "a"

    },
    {
      "ID": "301",
      "vMobile_Timestamp": "gg5",
      "GPS_Position": "hgh",
      "Call_Control_Event": "Speech Analysis event",
      "description": "a"

    }
  ];

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
  description: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {
    position: 1,
    name: 'Hydrogen',
    weight: 1.0079,
    symbol: 'H',
    description: `Hydrogen is a chemical element with symbol H and atomic number 1. With a standard
        atomic weight of 1.008, hydrogen is the lightest element on the periodic table.`
  }, {
    position: 2,
    name: 'Helium',
    weight: 4.0026,
    symbol: 'He',
    description: `Helium is a chemical element with symbol He and atomic number 2. It is a
        colorless, odorless, tasteless, non-toxic, inert, monatomic gas, the first in the noble gas
        group in the periodic table. Its boiling point is the lowest among all the elements.`
  }, {
    position: 3,
    name: 'Lithium',
    weight: 6.941,
    symbol: 'Li',
    description: `Lithium is a chemical element with symbol Li and atomic number 3. It is a soft,
        silvery-white alkali metal. Under standard conditions, it is the lightest metal and the
        lightest solid element.`
  }
];
